<template>
	<button @click="actionGoTo" class="sk-navigation-link-simple"><span>{{ title }}</span></button>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'navigation-link-text',
	props: {
		route: {
			type: String,
			default: null
		},
		routeStartsWith: {
			type: String,
			default: null
		},
		title: {
			type: String,
			default: null
		}
	},
	methods: {
		actionGoTo() {
			if (!this.route)
				return

			this.$root.$emit('navigation-close')

			this.$router.push({
				name: this.route,
				params: {
					user_uid: this.currentUser.uid
				}
			})

			this.$parent.$emit('close')
		}
	},
	computed: {
		isActive() {
			if (this.routeStartsWith) {
				return this.$route.name.startsWith(this.routeStartsWith)
			}
			return this.route === this.$route.name
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	}
}
</script>

<style scoped>
a > span,
button > span {
	transform: translate(0, 0);
	transition: all 300ms;
	display: inline-block;
	color: var(--main-font-color-invert-2);
}
a:hover > span,
button:hover > span {
	transform: translate(5px, 0);
	font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationLinkText.vue